import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'

// Material-UI
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { cloneDeep } from 'lodash'
import Button from '@mui/material/Button'
import './NewsDialog.scss'
import { IARRte } from '../iar-rte'
import ChooseImage from '../ChooseImage'
import { useCMSContext } from '../../CMS/CMSContext'
import ChooseVideo from '../ChooseVideo'
import CustomDropdown from '../Dropdown/dropdown'
import MediaThumbnail from '../../Shared/MediaThumbnail/MediaThumbnail'
import NewsDialogActions from './NewsDialogActions'
import ButtonSave from '../ButtonSave/ButtonSave'
import MediaFilesMessage from '../MediaFilesMessage'
import OnlineVideos from '../../Shared/OnlineVideos'
import { useErrorSnackBarContext } from '../ErrorSnackBar/ErrorSnackBarContext'
import { videoTypes } from '../../../Constants/videoTypes'
import { IARDialog } from '../../Shared/Dialog/IARDialog'
import Interceptor from '../../../Services/serviceBase.interceptor'
import serviceBase from '../../../Services/serviceBase'
import { useGetIsDemoDepartment } from '../../../../resources/useGetIsDemoDepartment'
import {
  getImagesPayload,
  getOnlineVideosPayload,
  getVideosPayload,
  setNewEncodingPayload
} from './NewsDialogFunctions'
import { EncondingSectionType } from 'app/Constants/EncodingSectionType'
import { saveSectionVideoProcess } from 'app/Services/serviceSectionsMediaShared'
import PrepublishButtons from 'app/Components/Shared/PrepublishButtons/PrepublishButtons'
import { EmptyTagsTypes } from 'app/Constants/bodyTextValidationsTypes'
import PreviewContentLabel from '../PreviewContentLabel/PreviewContentLabel'
const NewsDialog = React.memo(
  ({
    id,
    title,
    open,
    fireDepartmentIdentifier,
    onCancel,
    onClose,
    isItNew,
    posting,
    setPosting,
    disabledButton,
    setDisabledButton,
    socketResponse,
    showPublished
  }) => {
    const { errorSnackBarActions } = useErrorSnackBarContext()
    Interceptor.interceptor(errorSnackBarActions)
    const cmsContext = useCMSContext()
    const {
      fireDepartment,
      socket,
      iarMember,
      isReadOnlyMember,
      isDemoDepartments,
      newVideoEncoding,
      appConfiguration
    } = cmsContext.state
    const { isDemo } = useGetIsDemoDepartment(isDemoDepartments, fireDepartment)
    const INITIAL_STATE = {
      bodyText: '',
      title: '',
      positionFiles: 0,
      postMessage: '',
      sectionActive: true,
      fireDepartmentIdentifier: '',
      images: [],
      videos: [],
      onlineVideos: [],
      sendPushNotification: false
    }

    const [newsEntity, setNewsEntity] = useState(INITIAL_STATE)
    const [newsEntityDiscard, setNewsEntityDiscard] = useState(INITIAL_STATE)
    const [images, setImages] = useState([]) // this images is the one to be send in post
    const [videos, setVideos] = useState([]) // this images is the one to be send in post
    const [onlineVideos, setOnlineVideos] = useState([])
    const [dataPosted, setDataPosted] = useState({ posted: false, message: '' })
    const [deletedFiles, setDeletedFiles] = useState([])
    const [tempUpdatedFiles, setTempUpdatedFiles] = useState([])
    const [localId, setLocalId] = useState(id)
    const [errorLabel, setErrorLabel] = useState('')
    const [errorBodyText, setErrorBodyText] = useState('')
    const [errorTitle, setErrorTitle] = useState('')
    const [isDiscarded, setDiscarded] = useState(false)
    const [dialog, setDialog] = useState({ open: false })
    const [deletedSeconds, setDeletedSeconds] = useState([])
    const [isDiscardedMedia, setIsDiscardedMedia] = useState(false)
    const [bodyText, setBodyText] = useState('')

    useEffect(() => {
      setBodyText(newsEntity.bodyText || '')
    }, [newsEntity._id, newsEntity.bodyText])

    //Properties for preview
    const [isDiscardDialogOpen, setIsDiscardDialogOpen] = useState(false)
    const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false)
    const [isPreviewDialogOpen, setIsPreviewDialogOpen] = useState(false)
    const [isPreviewNotSaveDialogOpen, setIsPreviewNotSavedDialogOpen] = useState(false)

    const withNewEncodingProcess = useMemo(() => {
      return (
        newVideoEncoding &&
        videos?.some(
          (x) =>
            !newsEntityDiscard.videos?.some((v) => {
              return x.fileName === v.fileName
            })
        )
      )
    }, [newVideoEncoding, videos, newsEntityDiscard.videos])

    const disableContent = useMemo(() => {
      return appConfiguration.previewEnabled && showPublished
    }, [appConfiguration.previewEnabled, showPublished])

    const shouldDialogCloseRef = useRef(false)

    useEffect(() => {
      if (localId) {
        async function fetchDetail() {
          let response
          if (showPublished) response = await NewsDialogActions.getNewsDetail(localId)
          else response = await NewsDialogActions.getNewsPreviewDetail(localId)
          if (response) {
            setNewsEntity(response)
            setNewsEntityDiscard(cloneDeep(response))
            setImages(response.images ?? [])
            setVideos(response.videos ?? [])
            setOnlineVideos(response.onlineVideos ?? [])
          }
        }
        fetchDetail()
      }
      setPosting(false)
      setDisabledButton(false)
    }, [localId, setDisabledButton, setPosting, showPublished, onClose])

    useEffect(() => {
      setDisabledButton(showPublished)
    }, [setDisabledButton, showPublished])

    useEffect(() => {
      if (
        shouldDialogCloseRef.current &&
        socketResponse &&
        shouldDialogCloseRef.current.title === socketResponse.title &&
        shouldDialogCloseRef.current.socketChannels &&
        shouldDialogCloseRef.current.socketChannels.includes(socketResponse.channel)
      ) {
        onClose()
      }
    }, [socketResponse, onClose])

    useEffect(() => {
      if (fireDepartment && socket && newsEntity._id) {
        socket.on(
          `${fireDepartment.fireDepartmentId.toString()}_${newsEntity._id}_news_dialog`,
          (args) => {
            console.log(
              `${fireDepartment.fireDepartmentId.toString()}_${newsEntity._id}_news_dialog`,
              args,
              new Date()
            )
            if (args.param === 'start') {
              setDisabledButton(true)
            }
            if (args.param === 'error') {
              console.log('the current news', newsEntity)
              setDisabledButton(true)
            }
            if (args.param === 'saved') {
              setDisabledButton(false)
              setPosting(false)
              if (args.response) {
                setNewsEntity(args.response)
                setNewsEntityDiscard(args.response)

                if (args.response.images.length > 0) {
                  setImages(args.response.images)
                }
                if (args.response.videos.length > 0) {
                  setVideos(args.response.videos)
                }
                if (args.response.onlineVideos.length > 0) {
                  setOnlineVideos(args.response.onlineVideos)
                }
                if (args.response._id === newsEntity._id && args.memberId === iarMember.memberId) {
                  onClose()
                }
              }
            }
          }
        )
      }
      return () => {
        socket.off(`${fireDepartment.fireDepartmentId.toString()}_${newsEntity._id}_news_dialog`)
      }
    }, [
      fireDepartment,
      socket,
      newsEntity,
      iarMember.memberId,
      onClose,
      setDisabledButton,
      setPosting
    ])

    useEffect(() => {
      if (errorLabel !== '') {
        errorSnackBarActions.setOpen(true, errorLabel)
        setErrorLabel('')
      }
    }, [errorLabel, errorSnackBarActions])

    const rteChangeHandler = useCallback((content) => {
      setBodyText(content.trim())
    }, [])

    const renderRichTextControl = useCallback(() => {
      if (isDiscarded) {
        return (
          <IARRte
            onChange={rteChangeHandler}
            content={newsEntityDiscard.bodyText}
            discarded={isDiscarded}
            disableHandleChange={disableContent}
          />
        )
      } else {
        return (
          <IARRte
            onChange={rteChangeHandler}
            content={newsEntity.bodyText}
            discarded={isDiscarded}
            disableHandleChange={disableContent}
          />
        )
      }
    }, [isDiscarded, rteChangeHandler, newsEntityDiscard, newsEntity, disableContent])

    const handleCheckboxChange = useCallback((evt) => {
      const value = evt.target.checked
      setNewsEntity((prevState) => ({ ...prevState, sendPushNotification: value }))
    }, [])

    const handleDropdownChange = useCallback((evt) => {
      const value = evt.target.value
      setNewsEntity((prevState) => ({ ...prevState, positionFiles: value }))
    }, [])

    const handleChange = useCallback((evt) => {
      const value = evt.target.value
      setNewsEntity((prevState) => ({ ...prevState, [evt.target.name]: value }))
    }, [])

    const handleClose = (dataPosted = false) => {
      if (!localId) {
        setNewsEntity({ title: '', bodyText: '', positionFiles: 0, sendPushNotification: false })
        rteChangeHandler('')
      }
      setLocalId('')
      setImages([])
      setVideos([])
      dataPosted ? onCancel(dataPosted) : onCancel(isItNew)
    }

    const removeOnlineVideo = (file) => {
      const files = deletedFiles

      files.push(file)
      const tempOnlineVideos = onlineVideos.filter((i) => i.originalName !== file.originalName)
      setOnlineVideos(tempOnlineVideos)
    }

    const removeAsset = useCallback(
      (file, type) => {
        const files = deletedFiles
        const secondsDeleted = deletedSeconds

        switch (type) {
          case 'image':
            if (!file.isNew) {
              files.push(file.fileName)
              setDeletedFiles(files)
            }
            const tempImages = images.filter((i) => i.fileName !== file.fileName)
            setImages(tempImages)
            break
          case 'video':
            if (!file.isNew) {
              files.push(file.fileName)
              secondsDeleted.push(file.secondsDuration ? file.secondsDuration : 0)
              setDeletedFiles(files)
              setDeletedSeconds(secondsDeleted)
            }
            const tempVideos = videos.filter((i) => i.fileName !== file.fileName)
            setVideos(tempVideos)
            break
          default:
            break
        }
      },
      [deletedFiles, deletedSeconds, images, videos]
    )

    const updateAsset = useCallback(
      (file) => {
        if (tempUpdatedFiles.filter((el) => el.fileName === file.fileName).length > 0) {
          tempUpdatedFiles.filter((el) => el.fileName === file.fileName)[0].caption = file.caption
        } else {
          setTempUpdatedFiles([
            ...tempUpdatedFiles,
            { caption: file.caption, fileName: file.fileName }
          ])
        }
      },
      [tempUpdatedFiles]
    )

    const postNews = async () => {
      setDataPosted({ ...dataPosted, posted: false })
      setPosting(true)

      let readyToSave = isReadyToSave()
      if (!readyToSave) {
        setErrorLabel('Missing Information')
        errorSnackBarActions.setOpen(true, errorLabel)
        setDataPosted({ posted: false, message: 'Missing Information' })
        return
      }

      let url = `${window._env_.COMMUNITY_API_URL}/news-and-announcements`

      const online = getOnlineVideosPayload(onlineVideos, fireDepartment)
      const img = getImagesPayload(newsEntityDiscard, images)
      const vid = getVideosPayload(newsEntityDiscard, videos)

      const data = {
        _id: newsEntity._id || '',
        fireDepartmentIdentifier: fireDepartment.identifier,
        title: newsEntity.title,
        bodyText: bodyText,
        images: img,
        videos: vid,
        onlineVideos: online,
        positionFiles:
          newsEntity && newsEntity.positionFiles ? parseInt(newsEntity.positionFiles) : 0,
        filesToDelete: deletedFiles,
        filesToUpdate: tempUpdatedFiles,
        sendPushNotification: newsEntity.sendPushNotification,
        deletedSeconds: deletedSeconds
      }

      if (!newsEntity._id) {
        delete data._id
      }

      const formData = new FormData()

      formData.append('request', JSON.stringify(data))

      videos.forEach((video) => {
        if (video.binary === undefined) return

        formData.append('videos', video.binary, video.originalName)

        video.binary = null
      })

      images.forEach((image) => {
        if (image.file === undefined) return

        formData.append('images', image.file, image.originalName)
        image.file = null
      })
      await serviceBase.get(`${url}/emit-start/${fireDepartment.fireDepartmentId}?id=${data._id}`)

      serviceBase
        .post(url, formData, {
          fullusername: iarMember.fullName
        })
        .then(
          (response) => {
            setDataPosted({ posted: true, message: 'Saved' })
            setPosting(false)
            console.log('POST NewsDialog: ', response)
            handleClose(true)
            setDeletedSeconds([])
          },
          (err) => {
            errorSnackBarActions.setOpen(true)
            setDataPosted({ posted: false, message: 'Error while saving changes' })
            setPosting(false)
            console.log(err)
          }
        )
    }

    const postNewsPreview = async () => {
      setDataPosted({ ...dataPosted, posted: false })
      setPosting(true)

      let readyToSave = isReadyToSave()
      if (!readyToSave) {
        closePreviewDialog()
        setErrorLabel('Missing Information')
        errorSnackBarActions.setOpen(true, errorLabel)
        setDataPosted({ posted: false, message: 'Missing Information' })
        return
      }

      const online = getOnlineVideosPayload(onlineVideos, fireDepartment)
      const img = getImagesPayload(newsEntityDiscard, images)
      const vid = getVideosPayload(newsEntityDiscard, videos)

      const data = {
        _id: newsEntity._id || '',
        fireDepartmentIdentifier: fireDepartment.identifier,
        title: newsEntity.title,
        bodyText: bodyText,
        images: img,
        videos: vid,
        onlineVideos: online,
        positionFiles:
          newsEntity && newsEntity.positionFiles ? parseInt(newsEntity.positionFiles) : 0,
        filesToDelete: deletedFiles,
        filesToUpdate: tempUpdatedFiles,
        sendPushNotification: newsEntity.sendPushNotification,
        deletedSeconds: deletedSeconds
      }

      if (!newsEntity._id) {
        delete data._id
      }

      const formData = new FormData()

      formData.append('request', JSON.stringify(data))

      videos.forEach((video) => {
        if (video.binary === undefined) return

        formData.append('videos', video.binary, video.originalName)

        video.binary = null
      })

      images.forEach((image) => {
        if (image.file === undefined) return

        formData.append('images', image.file, image.originalName)
        image.file = null
      })
      await NewsDialogActions.getNewsEmitStart(fireDepartment, newsEntity._id)
      const url = `${window._env_.COMMUNITY_API_URL}/news-preview`

      serviceBase
        .post(url, formData, {
          fullusername: iarMember.fullName
        })
        .then(
          (response) => {
            setDataPosted({ posted: true, message: 'Saved' })
            setPosting(false)
            console.log('POST NewsDialog: ', response)
            handleClose(true)
            setDeletedSeconds([])
          },
          (err) => {
            errorSnackBarActions.setOpen(true)
            setDataPosted({ posted: false, message: 'Error while saving changes' })
            setPosting(false)
            console.log(err)
          }
        )
    }

    const cancelDialog = () => {
      setDialog({ open: false })
      setDiscarded(false)
    }

    const openConfirmationDialog = () => {
      setDialog({ open: true })
      setDiscarded(false)
    }

    const discardChanges = () => {
      setDialog({ open: false })
      setNewsEntity(cloneDeep(newsEntityDiscard))
      setImages(cloneDeep(newsEntityDiscard.images))
      setVideos(cloneDeep(newsEntityDiscard.videos))
      setOnlineVideos(cloneDeep(newsEntityDiscard.onlineVideos))
      setDeletedFiles([])
      setIsDiscardedMedia((prev) => !prev)
      setDiscarded((prevState) => !prevState)
      setTempUpdatedFiles([])
    }

    const isReadyToSave = () => {
      let readyToSave = true
      // eslint-disable-next-line react-hooks/exhaustive-deps
      let richText = bodyText || newsEntity.bodyText

      if (!richText || EmptyTagsTypes.EmptyTag.includes(richText)) {
        setErrorBodyText('This field is required!')
        setDisabledButton(false)
        setPosting(false)
        setTimeout(() => {
          setErrorBodyText('')
        }, 5000)
        readyToSave = false
      }

      if (!newsEntity.title || EmptyTagsTypes.EmptyTag.includes(newsEntity.title)) {
        setErrorTitle('This field is required!')
        setDisabledButton(false)
        setPosting(false)
        setTimeout(() => {
          setErrorTitle('')
        }, 5000)
        readyToSave = false
      }

      return readyToSave
    }

    const saveSectionVideoProcessNews = async (isPreview) => {
      try {
        setDataPosted({ ...dataPosted, posted: false })
        setPosting(true)
        setDisabledButton(true)
        closePreviewDialog()

        let readyToSave = isReadyToSave()
        if (!readyToSave) {
          setErrorLabel('Missing Information')
          errorSnackBarActions.setOpen(true, errorLabel)
          setDataPosted({ posted: false, message: 'Missing Information' })
          return
        }

        const online = getOnlineVideosPayload(onlineVideos ?? [], fireDepartment)
        const img = getImagesPayload(newsEntity, images ?? [])
        const vid = getVideosPayload(newsEntity, videos ?? [])
        const jsonData = setNewEncodingPayload(
          img,
          vid.length,
          online,
          isPreview ? EncondingSectionType.NewsPreview : EncondingSectionType.News,
          newsEntity,
          deletedFiles,
          fireDepartment,
          images,
          iarMember,
          tempUpdatedFiles,
          bodyText
        )

        shouldDialogCloseRef.current = jsonData

        await NewsDialogActions.getNewsEmitStart(fireDepartment, newsEntity._id)

        setPosting(true)

        const response = await saveSectionVideoProcess(jsonData, vid, images)
        if (response.encoderErrors?.length) {
          setErrorLabel(
            'There was an error uploading these files: ' + response.encoderErrors.join(', ')
          )
          errorSnackBarActions.setOpen(true, errorLabel)
          return
        }

        handleClose(true)
      } catch (error) {
        setErrorLabel('Unexpected error when uploading files')
        errorSnackBarActions.setOpen(true, errorLabel)
      } finally {
        setPosting(false)
        setDisabledButton(false)
        setDeletedSeconds([])
        setDeletedFiles([])
      }
    }

    const closeDiscardDialog = () => {
      setIsDiscardDialogOpen(false)
    }

    const openDiscardDialog = () => {
      setIsDiscardDialogOpen(true)
    }

    const openPreviewDialog = () => {
      setIsPreviewDialogOpen(true)
    }

    const closePreviewDialog = () => {
      setIsPreviewDialogOpen(false)
    }

    const closeSaveDialog = () => {
      setIsSaveDialogOpen(false)
    }

    const openSaveDialog = () => {
      setIsSaveDialogOpen(true)
    }

    const openNotSavedPreviewDialog = () => {
      setIsPreviewNotSavedDialogOpen(true)
    }

    const closeNotSavedPreviewDialog = () => {
      setIsPreviewNotSavedDialogOpen(false)
    }

    const savePublish = async () => {
      try {
        closeSaveDialog()
        setDataPosted({ ...dataPosted, posted: false })
        setPosting(true)

        const newsPublished = await NewsDialogActions.publish(
          newsEntity._id,
          newsEntity.sendPushNotification,
          iarMember
        )
        const newsDiscard = cloneDeep(newsPublished)

        setNewsEntity(newsPublished)
        setNewsEntityDiscard(newsDiscard)

        setImages(newsPublished.images ?? [])
        setVideos(newsPublished.videos ?? [])
        setOnlineVideos(newsPublished.onlineVideos ?? [])

        setDataPosted({ posted: true, message: 'Saved' })
        setDeletedSeconds([])
        setDeletedFiles([])
        setTempUpdatedFiles([])

        handleClose(true)
      } catch (error) {
        setErrorLabel('There was an error publishing News')
        errorSnackBarActions.setOpen(true, errorLabel)
      } finally {
        setPosting(false)
      }
    }

    const publishButtonValidations = () => {
      if (
        JSON.stringify(newsEntity) !== JSON.stringify(newsEntityDiscard) ||
        bodyText !== newsEntityDiscard.bodyText ||
        JSON.stringify(videos) !== JSON.stringify(newsEntity.videos) ||
        JSON.stringify(images) !== JSON.stringify(newsEntity.images) ||
        JSON.stringify(onlineVideos) !== JSON.stringify(newsEntity.onlineVideos)
      ) {
        openNotSavedPreviewDialog()
      } else {
        openSaveDialog()
      }
    }

    const saveDialogCustomContent = useMemo(
      () => (
        <Grid container>
          <Grid size={12}>You are about to publish the news content do you want to continue?</Grid>
          <Grid size={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="sendPushNotification"
                  color="primary"
                  className="checkbox-notification"
                  checked={newsEntity.sendPushNotification}
                  value={newsEntity.sendPushNotification}
                  onChange={handleCheckboxChange}
                  disabled={appConfiguration.previewEnabled && showPublished}
                />
              }
              label="Send notification to users when saved"
            />
          </Grid>
        </Grid>
      ),
      [
        newsEntity.sendPushNotification,
        appConfiguration.previewEnabled,
        showPublished,
        handleCheckboxChange
      ]
    )

    return (
      <>
        <IARDialog
          open={isPreviewNotSaveDialogOpen}
          title="Save Preview first"
          content="Please save your changes in preview before publishing"
          onOk={closeNotSavedPreviewDialog}
          onCancel={closeNotSavedPreviewDialog}
          previewNotSaved={true}
        />
        <Dialog className="news-dialog" disableBackdropClick disableEscapeKeyDown open={open}>
          <DialogTitle className="news-dialog-title">
            <span>{title}</span>
            <IconButton aria-label="close" className="close-button" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className="news-dialog-content">
            <IARDialog
              open={dialog.open}
              title="Confirm"
              content="Do you want to discard your changes?"
              onOk={discardChanges}
              onCancel={cancelDialog}
            />
            <form noValidate autoComplete="off">
              <Grid size={12}>
                <Grid container>
                  <PreviewContentLabel
                    showPublished={showPublished}
                    previewEnabled={appConfiguration.previewEnabled}
                  />
                </Grid>
                <Grid container className="title-container">
                  <Grid size={12} className="container-field-label" style={{ marginTop: 0 }}>
                    <label htmlFor="title" className="label-container label-news">
                      Title
                    </label>
                  </Grid>
                  <Grid size={12} className="container-field">
                    <label htmlFor="error" className="error-text">
                      {errorTitle}
                    </label>
                    <TextField
                      id="title"
                      name="title"
                      multiline
                      rows={2}
                      variant="outlined"
                      className="news-textfield"
                      value={newsEntity.title}
                      onChange={handleChange}
                      disabled={disableContent}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid size={12} className="container-field  body-text">
                    <label htmlFor="message" className="label-container">
                      Content
                    </label>
                  </Grid>
                  <Grid size={12} className="container-field body-text">
                    <label htmlFor="error" className="error-text">
                      {errorBodyText}
                    </label>
                    {renderRichTextControl()}
                  </Grid>
                </Grid>
                <Grid size={12}>
                  <div className="container-field dropdown-container">
                    <div>
                      <label htmlFor="positionFiles">Position images and videos</label> <br />
                      <CustomDropdown
                        name="positionFiles"
                        value={newsEntity.positionFiles || 0}
                        onChange={handleDropdownChange}
                        disableHandleChange={disableContent}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid container>
                  <Grid size={12}>
                    <Grid className="container-field">
                      <label htmlFor="images" className="body-text">
                        Media Files
                      </label>
                      <MediaFilesMessage max={5}></MediaFilesMessage>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, md: 6 }} className="media-files">
                    <ChooseImage
                      images={images}
                      setImages={setImages}
                      fireDepartmentIdentifier={fireDepartmentIdentifier}
                      max={5}
                      elementsAdded={images.length + videos.length}
                      setErrorLabel={setErrorLabel}
                      isMessageEnabled={false}
                      disableHandleClick={disableContent}
                    />
                    <>
                      {images.map((el, index) => {
                        return (
                          <MediaThumbnail
                            isDiscardedMedia={isDiscardedMedia}
                            type="image"
                            key={el.fileName ? el.fileName : index}
                            media={el}
                            removeMediaEvent={removeAsset}
                            onUpdate={updateAsset}
                            disableHandleClick={disableContent}
                          />
                        )
                      })}
                    </>
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }} className="media-files">
                    <ChooseVideo
                      videos={videos}
                      setVideos={setVideos}
                      fireDepartmentIdentifier={fireDepartmentIdentifier}
                      max={5}
                      elementsAdded={images.length + videos.length}
                      setErrorLabel={setErrorLabel}
                      isMessageEnabled={false}
                      disableHandleClick={disableContent}
                    />
                    <>
                      {videos.map((el, index) => {
                        return (
                          <MediaThumbnail
                            isDiscardedMedia={isDiscardedMedia}
                            type="video"
                            key={el.fileName ? el.fileName : index}
                            media={el}
                            removeMediaEvent={removeAsset}
                            index={index}
                            onUpdate={updateAsset}
                            disableHandleClick={disableContent}
                          />
                        )
                      })}
                    </>
                  </Grid>
                  <Grid size={12} className="container-field media-files">
                    <OnlineVideos
                      videos={onlineVideos}
                      setOnlineVideos={setOnlineVideos}
                      setErrorLabel={setErrorLabel}
                      max={5}
                      disableHandleClick={disableContent}
                    />
                    <>
                      {onlineVideos && (
                        <Grid container>
                          {onlineVideos &&
                            onlineVideos.map((el, index) => {
                              return (
                                <Grid size={12} className="container-field media-files">
                                  <MediaThumbnail
                                    isDiscardedMedia={isDiscardedMedia}
                                    type="online"
                                    key={el.fileName ? el.fileName : index}
                                    media={el}
                                    removeMediaEvent={removeAsset}
                                    index={index}
                                    subType={videoTypes.YoutubeVideos}
                                    onUpdate={updateAsset}
                                    removeOnlineVideo={removeOnlineVideo}
                                    disableHandleClick={disableContent}
                                  />
                                </Grid>
                              )
                            })}
                        </Grid>
                      )}
                    </>
                  </Grid>
                </Grid>
                <Grid container>
                  {!isDemo && !appConfiguration.previewEnabled && (
                    <Grid size={12} className="container-field">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="sendPushNotification"
                            color="primary"
                            className="checkbox-notification"
                            value={newsEntity.sendPushNotification}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Send notification to users when saved"
                      />
                    </Grid>
                  )}
                </Grid>
                <Grid container>
                  <Grid size={12} className="container container-buttons">
                    {appConfiguration?.previewEnabled ? (
                      <PrepublishButtons
                        isDiscardDialogOpen={isDiscardDialogOpen}
                        isPreviewDialogOpen={isPreviewDialogOpen}
                        isReadOnlyMember={isReadOnlyMember}
                        isShown={appConfiguration.previewEnabled}
                        isSaveDialogOpen={isSaveDialogOpen}
                        openPreviewDialog={openPreviewDialog}
                        openDiscardDialog={openDiscardDialog}
                        closePreviewDialog={closePreviewDialog}
                        closeDiscardDialog={closeDiscardDialog}
                        closeSaveDialog={closeSaveDialog}
                        discardChanges={discardChanges}
                        disabledButton={disabledButton}
                        publishButtonValidations={publishButtonValidations}
                        posting={posting}
                        savePreview={
                          withNewEncodingProcess
                            ? () => saveSectionVideoProcessNews(true)
                            : () => postNewsPreview()
                        }
                        savePublish={savePublish}
                        saveDialogCustomContent={saveDialogCustomContent}
                      />
                    ) : (
                      <div className="save-button-container">
                        <ButtonSave
                          id="saveButton"
                          loading={posting}
                          onClickCallback={
                            withNewEncodingProcess
                              ? () => saveSectionVideoProcessNews(false)
                              : () => postNews()
                          }
                          disabled={isReadOnlyMember}
                        />
                        <Button
                          style={{ maxWidth: '250px', minWidth: '250px' }}
                          disabled={isReadOnlyMember || posting}
                          variant="outlined"
                          id="cancelButton"
                          color="primary"
                          size="medium"
                          onClick={openConfirmationDialog}
                        >
                          Discard
                        </Button>
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </DialogContent>
        </Dialog>
      </>
    )
  }
)

export default NewsDialog
